/**
 * 复制内容到剪切板
 * @param val
 */
export const copyToClipBoard = (val: string) => {
  if (typeof document.execCommand !== 'function') {
    return false;
  }
  const textarea = document.createElement('textarea');
  textarea.setAttribute('readonly', 'readonly');
  textarea.value = val;
  // textarea.setAttribute('value', val)
  document.body.appendChild(textarea);
  // TODO: no support safari
  textarea.select();
  const res = document.execCommand('copy');
  document.body.removeChild(textarea);
  return res;
};

export default copyToClipBoard;
